import React from "react";
import { PageWrapper } from "../containers";
import { OthersContainer } from "../containers/others-container/OthersContainer";

const Others = () => (
  <PageWrapper 
  containerClassName="no-padding"
  pageContainerChildren={<OthersContainer />} />
);

export default Others;
